export const EMPTY_FUNCTION: (...args: Array<any>) => void = () => {};
